module.exports = __webpack_public_path__ + "img/historia1.1c9fd9b7.jpg";